import createGlobalState from "@ui/lib/createGlobalState";
import {
  DEFAULT_QUANTITY_FILTER_VALUES,
  QuantityFilteredValues,
} from "../../Settings/Quantities/utils/quantityFilters";

export const useQuantitySelectorFilteredValues = createGlobalState({
  storage: "session",
  key: "quantitySelectorFilteredValues",
  type: QuantityFilteredValues,
  defaultValue: DEFAULT_QUANTITY_FILTER_VALUES,
  scoped: true,
});
